/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

const Header = () => {
  return (
    <header className="pt-3 pb-2 px-2 px-sm-4 pt-md-3 px-md-4 pt-lg-4 my-lg-1 px-lg-5">
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <a className="navbar-brand fs-2" href="/">
            Safe Retirement Spending
          </a>
        </div>
      </nav>
    </header>
  )
}

export default Header
